import React from "react";

import Label from "../../../Form/Label";


const HeaderAndHero = ({
  formData,
  setFormData,
  loadingState,
  sizeGuide,
  sampleGuide,
  handleImageChange,
  handelDeleteImages,
}) => {
  console.log(sampleGuide);

  return (
    <main className="flex w-full justify-between gap-6">
      <div  className="bg-white h-fit  flex flex-col gap-3 rounded-[10px] p-[30px] w-[42%]">
        <div className="text-customGreen  text-[17px] mb-4 font-semibold">Section Layout</div>
        <img src={sampleGuide?.headerAndHero} className="w-full" alt="Header and Hero Preview" />
      </div>
      <div className="bg-white overflow-x-auto min-h-72 rounded-[10px] p-[30px] flex-1">
      <div className="text-customGreen text-[17px] font-semibold mb-8  " >Header & Hero Section</div>

        <div className="w-full pb-16 flex flex-col gap-3">
          {/* Header Logo Upload */}
          <div className="flex justify-between gap-2">
            <div className="flex gap-2">
              <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
              <Label label="Header Logo" />
            </div>
            <div className="flex flex-col items-center justify-center w-[75%]">
              <label
                htmlFor="header-logo-file"
                className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg className="w-8 h-8 mb-4 text-customGreen" fill="none" viewBox="0 0 20 16">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500">
                    <span className="font-semibold">Click to upload</span> or drag and drop
                  </p>
                  <p className="text-xs text-gray-500">
                    PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                    {sizeGuide?.logo || "Max 800x400px"}
                  </p>
                </div>
                <input
                  id="header-logo-file"
                  type="file"
                  className="hidden"
                  disabled={loadingState.logo || formData.header.logo}
                  onChange={(e) => handleImageChange(e, "logo")}
                />
              </label>

              {loadingState.logo && (
                <div className="flex flex-col items-center mt-4">
                  <div className="spinner"></div>
                  <p className="text-sm text-gray-600 mt-2">Uploading image, please wait...</p>
                </div>
              )}

              {formData.header.logo && !loadingState.logo && (
                <div className="mt-4 relative">
                  <img
                    src={formData.header.logo}
                    alt="Header Logo"
                    className="w-16 h-16 rounded-lg shadow-md border border-gray-200"
                  />
                  <button
                    className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                    onClick={() => handelDeleteImages(formData.header.logo, "logo")}
                  >
                    X
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Phone Number */}
          <div className="flex justify-between gap-2">
            <div className="flex gap-2">
              <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
              <Label label="Display Phone Number" />
            </div>
            <div className="flex items-center justify-center w-[75%]">
              <input
                type="text"
                placeholder="Enter number"
                value={formData.header.phoneNumber}
                onChange={(e) => {
                  const input = e.target.value;
                  if (/^\d*$/.test(input)) {
                    setFormData({
                      ...formData,
                      header: { ...formData.header, phoneNumber: input },
                    });
                  }
                }}
                maxLength={10}
                className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
              />
            </div>
          </div>
        </div>

       

        <div className="flex flex-col gap-3">
          {/* Banner Image Upload */}
          <div className="flex justify-between gap-2">
            <div className="flex gap-2">
              <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
              <Label label="Slider Image" />
            </div>
            <div className="flex flex-col items-center justify-center w-[75%]">
              <label
                htmlFor="hero-banner-file"
                className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg className="w-8 h-8 mb-4 text-customGreen" fill="none" viewBox="0 0 20 16">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500">
                    <span className="font-semibold">Click to upload</span> or drag and drop
                  </p>
                  <p className="text-xs text-gray-500">
                    PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                    {sizeGuide?.heroBannerSize || "Max 800x400px"}
                  </p>
                </div>
                <input
                  id="hero-banner-file"
                  type="file"
                  className="hidden"
                  onChange={(e) => handleImageChange(e, "bannerImages")}
                />
              </label>

              {loadingState.bannerImages && (
                <div className="flex flex-col items-center mt-4">
                  <div className="spinner"></div>
                  <p className="text-sm text-gray-600 mt-2">Uploading image, please wait...</p>
                </div>
              )}

              {formData.hero.bannerImages.length > 0 && !loadingState.bannerImages && (
                <div className="mt-4 flex gap-2 relative">
                  {formData.hero.bannerImages.map((image, index) => (
                    <div key={index} className="relative">
                      <img
                        src={image}
                        alt={`Banner Preview ${index + 1}`}
                        className="w-16 h-16 rounded-lg shadow-md"
                      />
                      <button
                        className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                        onClick={() => handelDeleteImages(image, "bannerImages")}
                      >
                        X
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Title */}
          <div className="flex justify-between gap-2">
            <div className="flex gap-2">
              <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
              <Label label="Slider Title" />
            </div>
            <div className="flex items-center justify-center w-[75%]">
              <input
                type="text"
                placeholder="Enter Title"
                value={formData.hero.title}
                onChange={(e) =>
                  setFormData({ ...formData, hero: { ...formData.hero, title: e.target.value } })
                }
                maxLength={50}
                className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
              />
            </div>
          </div>

          {/* Description */}
          <div className="flex justify-between gap-2">
            <div className="flex gap-2">
              <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
              <Label label="Slider Description" />
            </div>
            <div className="flex items-center justify-center w-[75%]">
              <textarea
                placeholder="Enter Description"
                value={formData.hero.description}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    hero: { ...formData.hero, description: e.target.value },
                  })
                }
                maxLength={90}
                className="w-full h-24 px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default HeaderAndHero;